document.addEventListener("DOMContentLoaded", () => {
 
  // Step-1 Slider
  const customMediaSlider = new Swiper(".custom-media-slider", {
    slidesPerView: 1.5,
    spaceBetween: 16,
    navigation: {
      nextEl: ".swiper-button-media-next",
      prevEl: ".swiper-button-media-prev",
    },
    breakpoints: {
      640 : {
        slidesPerView: 2.4,
        spaceBetween: 24,
      },
      
    }
  });

  // Video Play/Pause Functionality
document.querySelectorAll(".play-button").forEach(function (button) {
    button.addEventListener("click", function () {
      let videoId = this.getAttribute("data-video-id");
      let videoElement = document.querySelector(`[data-video-id="${videoId}"]`);

      if (videoElement) {
        if (videoElement.paused) {
          videoElement.play();
          this.innerHTML = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="Media / Pause_Circle"> <path id="Vector" d="M14 9V15M10 9V15M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g> </g></svg>`;
        } else {
          videoElement.pause();
          this.innerHTML = `<svg class="play-icon" width="47" height="49" viewBox="0 0 47 49" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M23.5 0C10.5181 0 0 10.885 0 24.3197C0 37.7544 10.5181 48.6394 23.5 48.6394C36.4819 48.6394 47 37.7544 47 24.3197C47 10.885 36.4819 0 23.5 0ZM34.4635 26.6732L17.7861 36.5776C16.2889 37.4406 14.4032 36.3325 14.4032 34.5183V14.1211C14.4032 12.3168 16.2794 11.1988 17.7861 12.0618L34.4635 22.5546C36.0175 23.4568 36.0175 25.7809 34.4635 26.6732Z" fill="white" fill-opacity="0.8"/>
          </svg>`;
        }
      }
    });
  });

  // Step-3 Review Slider
  const reviewslidermobile = new Swiper(".review-slider-mobile", {
    pagination: {
      el: ".swiper-pagination-review-mobile",
      clickable: true, // Enables clicking on dots for navigation
    },
    loop: true, // Optional for looping slides
  });
    const reviewsliderdesktop = new Swiper(".review-slider-desktop", {
    pagination: {
      el: ".swiper-pagination-review-desktop",
      clickable: true, // Enables clicking on dots for navigation
    },
    loop: true, // Optional for looping slides
  });

  const step1Display = document.querySelector(".step-1-display");
  const step2Display = document.querySelector(".step-2-display");
  const step3Display = document.querySelector(".step-3-display");
  const step4Display = document.querySelector(".step-4-display");
  const createButtons = document.querySelectorAll(".create-btn");
  const step2CacelBtn = document.querySelectorAll(".step-2-cancel-btn");
  const step2NextBtn = document.querySelectorAll(".step-2-nxt-btn");
  const step3CacelBtn = document.querySelectorAll(".step-3-cancel-btn");
  const step3NextBtn = document.querySelectorAll(".step-3-nxt-btn");
  const inputFileSingle = document.getElementById("file-select-the-imges");
  const inputFile = document.getElementById("file-select-multiple-imges");
  const uploadButton = document.getElementById("button-select-multiple-imges");
  const loadingOver = document.getElementById("loading-overlay");
  const errorMessage = document.getElementById("errorMessage");
  const errorMessageMulti = document.getElementById("errorMessageMulti");

  // Elements to toggle after button click for step1-and ste2 backbtn
  const imageWithTextAndReview = document.querySelector(
    ".image-with-text-and-review"
  );
  const sectionSpacing = document.querySelector(
    ".section-spacing.color-scheme"
  );
  
// Function after create is clicked in step-1
  createButtons.forEach((button) => {
    button.addEventListener("click", () => {
      console.log('main button is clicked',button)
      // Hide step 1

      step1Display.style.display = "none";

      // Show step 2
      step2Display.style.display = "block";

      // Add active class to the second step
      const step2Wrapper = document.querySelectorAll(".step-wrapper")[1]; // Second step
      if (step2Wrapper) {
        step2Wrapper.classList.add("active");
      }
      // Add active class to the second step
      const step2Wrapper_mobile = document.querySelectorAll(".step-counter-mobile")[0]; // Second step
      if (step2Wrapper_mobile) {
        step2Wrapper_mobile.classList.add("active");
      }

      // Hide additional elements
      if (imageWithTextAndReview) {
        imageWithTextAndReview.style.display = "none";
      }
      if (sectionSpacing) {
        sectionSpacing.style.display = "none";
      }

      // Scroll to the top of the page
      window.scrollTo({
        top: 0,
        behavior: "smooth", // Adds a smooth scrolling effect
      });
    });  
  });
// add step=2 as param in url for  qr content
      if(window.location.href.includes('step=2')){
          document.querySelector('.create-btn').click()
      }

  //function after step-2 next btn is clicked

  if (step2Display && step3Display && step2NextBtn) {
    step2NextBtn.forEach((button) => {
      button.addEventListener("click", (event) => {
        // Check if exactly one file is selected
        if (!inputFileSingle.files.length) {
          event.preventDefault(); // Prevent proceeding to the next step
          errorMessage.textContent =
            "Please select one file before proceeding.";
          errorMessage.style.display = "block"; // Show the error message
             // Scroll to the top of the page
          window.scrollTo({
            top: 0,
            behavior: "smooth", // Adds a smooth scrolling effect
          });
        } else if (inputFileSingle.files.length > 1) {
          event.preventDefault(); // Prevent proceeding if more than one file is selected
          errorMessage.textContent = "Please select only one file.";
          errorMessage.style.display = "block"; // Show the error message
        } else {
          errorMessage.style.display = "none"; // Hide the error message if validation passes

          // Hide step 2
          step2Display.style.display = "none";

          // Show step 3
          step3Display.style.display = "block";

          // Add active class to the third step
          const step3Wrapper = document.querySelectorAll(".step-wrapper")[2]; // Third step
          if (step3Wrapper) {
            step3Wrapper.classList.add("active");
          }
          // Add active class to the third step
          const step3Wrapper_mobile = document.querySelectorAll(".step-counter-mobile")[1]; // Third step
          if (step3Wrapper_mobile) {
            step3Wrapper_mobile.classList.add("active");
          }

          // Scroll to the top of the page
          window.scrollTo({
            top: 0,
            behavior: "smooth", // Adds a smooth scrolling effect
          });
        }
      });
    });
  }

  //function after step-3 next btn is clicked

  if (step3Display && step4Display && step3NextBtn) {
    step3NextBtn.forEach((button) => {
      button.addEventListener("click", (event) => {
        if (!inputFile.files.length) {
          event.preventDefault(); // Prevent form submission or next step
          errorMessageMulti.textContent =
            "Please select at least one image before proceeding.";
          errorMessageMulti.style.display = "block"; // Show the error message
             // Scroll to the top of the page
          window.scrollTo({
            top: 0,
            behavior: "smooth", // Adds a smooth scrolling effect
          });
          // } else if (inputFile.files.length < 30 || inputFile.files.length > 150) {
          //   // Check if the number of selected files is not within the allowed range
          //   event.preventDefault(); // Prevent form submission or next step
          //   errorMessageMulti.textContent = 'Please select between 30 and 150 files.';
          //   errorMessageMulti.style.display = 'block'; // Show the error message
        } else {
          errorMessageMulti.style.display = "none"; // Hide the error message if validation passes

           // Show step 4

          // step4Display.style.display = "block";
          loadingOver.style.display = "block";
         // animateLoading();
          const mobileCounterStep = document.querySelector(".rendered-mobile-step-counter");
          mobileCounterStep.scrollLeft = mobileCounterStep.scrollWidth;

          // Hide step 3
          step3Display.style.display = "none";

          // Add active class to the fourth step
          const step4Wrapper = document.querySelectorAll(".step-wrapper")[3];
          if (step4Wrapper) {
            step4Wrapper.classList.add("active");
          }
          // Add active class to the fourth step
          const step4Wrapper_mobile = document.querySelectorAll(".step-counter-mobile")[2];
          if (step4Wrapper_mobile) {
            step4Wrapper_mobile.classList.add("active");
          }
           console.log('step 4 checking',step4Display)
          // const overlaystep4 = step4Display.querySelector('.loading-overlay');
          // overlaystep4.style.display ='block'
        }
      });
    });
  }

  //function after step-2 cancel button is clicked
  if (step2Display && step3Display && step2CacelBtn) {
    step2CacelBtn.forEach((button) => {
      button.addEventListener("click", () => {
        // hide step 2
        step2Display.style.display = "none";

        // show step 1
        step1Display.style.display = "block";

        // remove active class to the second step
        const step2Wrapper = document.querySelectorAll(".step-wrapper")[1]; // Second step
        if (step2Wrapper) {
          step2Wrapper.classList.remove("active");
        }
        // remove active class to the second step
        const step2Wrapper_mobile = document.querySelectorAll(".step-counter-mobile")[0]; // Second step
        if (step2Wrapper_mobile) {
          step2Wrapper_mobile.classList.remove("active");
        }
        // show additional elements
        if (imageWithTextAndReview) {
          imageWithTextAndReview.style.display = "block";
        }
        if (sectionSpacing) {
          sectionSpacing.style.display = "block";
        }
      });
    });
  }

  //function after step-3 cancel button is clicked
  if (step2Display && step3Display && step3CacelBtn) {
    step3CacelBtn.forEach((button) => {
      button.addEventListener("click", () => {
        // show step 2
        step2Display.style.display = "block";

        // hide step 3
        step3Display.style.display = "none";

        // remove active class to the third step
        const step3Wrapper = document.querySelectorAll(".step-wrapper")[2]; // Third step
        if (step3Wrapper) {
          step3Wrapper.classList.remove("active");
        }
        // remove active class to the third step
        const step3Wrapper_mobile = document.querySelectorAll(".step-counter-mobile")[1]; // Third step
        if (step3Wrapper_mobile) {
          step3Wrapper_mobile.classList.remove("active");
        }
      });
    });
  }

  //X button to delete functionality of step-2
  // Delete button functionality for single image
  document
    .getElementById("deleteSingleImg")
    .addEventListener("click", function () {
      const fileInput = document.getElementById("file-select-the-imges");
      const fileNameText = document.getElementById("fileName-select-the-imges");
      const imagePreview = document.getElementById("image-preview");
      const successMessage = document.getElementById("successMessage");
      const deleteBtn = document.getElementById("deleteButton");

      // Clear the file input
      fileInput.value = "";
      fileNameText.textContent = "No file chosen";

      // Hide the preview and reset success message
      imagePreview.style.display = "none";
      successMessage.style.display = "none";

      // Hide the delete button
      deleteBtn.style.display = "none";
    });

  //X button to delete functionality of step-3
  // Delete button functionality for multi image
document
  .getElementById("deleteMultipleImg")
  .addEventListener("click", function () {
    // Clear file input field
    const fileInput = document.getElementById("file-select-multiple-imges");
    fileInput.value = "";

    // Remove all dynamically added hidden inputs
    document
      .querySelectorAll(".dynamic-hidden-input-select-multiple-imges")
      .forEach((input) => input.remove());

    // Clear the preview container
    const previewContainer = document.getElementById("image-preview-container");
    previewContainer.innerHTML = "";

    // Reset the file name display
    const fileNameDisplay = document.getElementById("fileName-select-multiple-imges");
    fileNameDisplay.textContent = "No file chosen";

    // Reset the progress bar
    document.getElementById("file-upload-progress").value = 0;

    // Hide any error messages
    const errorMessage = document.getElementById("errorMessage");
    if (errorMessage) errorMessage.style.display = "none";
  });


  //single file-upload's js content
  document
    .getElementById("file-select-the-imges")
    .addEventListener("change", function (event) {
      const files = event.target.files;
      let fileName;
      const imagePreview = document.getElementById("image-preview");
      const successMessage = document.getElementById("successMessage");
      const deleteBtn = document.getElementById("deleteButton");

      // Reset success and error messages on file change
      successMessage.style.display = "none";
      document.getElementById("errorMessage").style.display = "none";

      if (files.length === 0) {
        fileName = "No file chosen";
        imagePreview.style.display = "none";
      } else if (files.length === 1) {
        fileName = files[0].name;

        const reader = new FileReader();
        reader.onload = function (e) {
          imagePreview.src = e.target.result;
          imagePreview.style.display = "block";

          // Show success message after image upload
          successMessage.style.display = "block";
          deleteBtn.style.display = "block";
        };
        reader.readAsDataURL(files[0]);
      } else {
        fileName = files.length + " files";
        imagePreview.style.display = "none";
      }

      document.getElementById("fileName-select-the-imges").textContent =
        fileName;
    });

  document
    .getElementById("button-select-the-imges")
    .addEventListener("click", function () {
      document.getElementById("file-select-the-imges").click();
    });

  document.addEventListener("DOMContentLoaded", () => {
    document
      .querySelector(".upload-form-single__submit")
      .addEventListener("click", function (event) {
        const inputFile = document.getElementById("file-select-the-imges");
        if (!inputFile.files.length && inputFile.required) {
          document.getElementById("errorMessage").style.display = "block";
        
        }
      });
  });

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelector("form[novalidate]").removeAttribute("novalidate");
  });

  // Delete button functionality
  document
    .getElementById("deleteButtonAction")
    .addEventListener("click", function () {
      const fileInput = document.getElementById("file-select-the-imges");
      const fileNameText = document.getElementById("fileName-select-the-imges");
      const imagePreview = document.getElementById("image-preview");
      const successMessage = document.getElementById("successMessage");
      const deleteBtn = document.getElementById("deleteButton");

      // Clear the file input
      fileInput.value = "";
      fileNameText.textContent = "No file chosen";

      // Hide the preview and reset success message
      imagePreview.style.display = "none";
      successMessage.style.display = "none";

      // Hide the delete button
      deleteBtn.style.display = "none";
    });

  //for multi-file upload content js
document
  .getElementById("file-select-multiple-imges")
  .addEventListener("change", function (event) {
    const files = event.target.files;
    const fileInput = document.getElementById("file-select-multiple-imges");
    const originalForm = fileInput.getAttribute("form");
    const maxFiles = 150; // Assuming 150 is the max limit for progress bar
    const progressBar = document.getElementById("file-upload-progress");

    // Remove previous dynamic inputs and image previews
    fileInput.parentNode
      .querySelectorAll(".dynamic-hidden-input-select-multiple-imges")
      .forEach((input) => input.remove());
    document.getElementById("image-preview-container").innerHTML = "";

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const hiddenInput = document.createElement("input");
      let myindex = i + 2;
      hiddenInput.name = "properties[select multiple images " + myindex + "]";
      hiddenInput.classList.add("dynamic-hidden-input-select-multiple-imges");
      hiddenInput.classList.add("hidden-input-fileupload");
      hiddenInput.style.display = "none";
      hiddenInput.setAttribute("form", originalForm);
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      hiddenInput.files = dataTransfer.files;
      fileInput.parentNode.appendChild(hiddenInput);

      // Create an image preview
      const reader = new FileReader();
      reader.onload = function (e) {
        const imgElement = document.createElement("img");
        imgElement.src = e.target.result;

        // Create a new container for each image
        const imageItemContainer = document.createElement("div");
        imageItemContainer.classList.add("image-item");

        // Create delete button
        const deleteButtonWrapper = document.createElement("div");
        deleteButtonWrapper.classList.add("delete-btn-wrapper");
        deleteButtonWrapper.id = "deleteButton";

        const deleteButton = document.createElement("button");
        deleteButton.id = "deleteButtonAction";

        // SVG inside delete button
        deleteButton.innerHTML = `
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.3 0.710001C12.91 0.320001 12.28 0.320001 11.89 0.710001L6.99997 5.59L2.10997 0.700001C1.71997 0.310001 1.08997 0.310001 0.699971 0.700001C0.309971 1.09 0.309971 1.72 0.699971 2.11L5.58997 7L0.699971 11.89C0.309971 12.28 0.309971 12.91 0.699971 13.3C1.08997 13.69 1.71997 13.69 2.10997 13.3L6.99997 8.41L11.89 13.3C12.28 13.69 12.91 13.69 13.3 13.3C13.69 12.91 13.69 12.28 13.3 11.89L8.40997 7L13.3 2.11C13.68 1.73 13.68 1.09 13.3 0.710001Z" fill="#0B0B0B"/>
          </svg>
        `;

        // Add delete button to the wrapper
        deleteButtonWrapper.appendChild(deleteButton);

        // Add image and delete button to the container
        imageItemContainer.appendChild(imgElement);
        imageItemContainer.appendChild(deleteButtonWrapper);

        // Append the container to the preview area
        document
          .getElementById("image-preview-container")
          .appendChild(imageItemContainer);

        // Add event listener to the delete button
        deleteButton.addEventListener("click", () => {
          imageItemContainer.remove(); // Remove the image container when delete button is clicked
          updateProgressBar();
        });
      };
      reader.readAsDataURL(file);
    }

    // Update the progress bar
    const updateProgressBar = () => {
      const totalFiles = fileInput.files.length;
      const percentage = Math.min((totalFiles / maxFiles) * 100, 100);
      console.log("percentage=",percentage);
      progressBar.value = percentage;
    };
    updateProgressBar();

    let fileName;
    if (files.length === 0) {
      fileName = "No file chosen";
    } else if (files.length === 1) {
      fileName = files[0].name;
      document.getElementById("errorMessageMulti").style.display = "none";
    } else {
      fileName = files.length + " files";
      document.getElementById("errorMessageMulti").style.display = "none";
    }
    document.getElementById("fileName-select-multiple-imges").textContent =
      "Uploaded Images";
  });

document
  .getElementById("button-select-multiple-imges")
  .addEventListener("click", function () {
    document.getElementById("file-select-multiple-imges").click();
  });

// document
//   .querySelector(".upload-form-multi__submit")
//   .addEventListener("click", function (event) {
//     const inputFile = document.getElementById("file-select-multiple-imges");
//     if (!inputFile.files.length && inputFile.required) {
//       document.getElementById("errorMessageMulti").style.display = "block";
//     }
//   });
    const submitButton = document.querySelector(".upload-form-multi__submit");
  if (submitButton) {
    submitButton.addEventListener("click", function (event) {
      const inputFile = document.getElementById("file-select-multiple-imges");
      if (!inputFile.files.length && inputFile.required) {
        document.getElementById("errorMessageMulti").style.display = "block";
      }
    });
  }

//   var checkmarkIdPrefix = "loadingCheckSVG-";
// var checkmarkCircleIdPrefix = "loadingCheckCircleSVG-";
// var verticalSpacing = 50;

// function shuffleArray(array) {
//     for (let i = array.length - 1; i > 0; i--) {
//         let j = Math.floor(Math.random() * (i + 1));
//         [array[i], array[j]] = [array[j], array[i]];
//     }
//     return array;
// }

// function createSVG(tag, properties, opt_children) {
//   let newElement = document.createElementNS("http://www.w3.org/2000/svg", tag);
//   for (let prop in properties) {
//     newElement.setAttribute(prop, properties[prop]);
//   }
//   if (opt_children) {
//     opt_children.forEach(child => newElement.appendChild(child));
//   }
//   return newElement;
// }

// function createPhraseSvg(phrase, yOffset) {
//   let text = createSVG("text", {
//     fill: "white",
//     x: 50,
//     y: yOffset,
//     "font-size": 18,
//     "font-family": "Arial"
//   });
//   text.appendChild(document.createTextNode(phrase + "..."));
//   return text;
// }

// function createCheckSvg(yOffset, index) {
//   let check = createSVG("polygon", {
//     points: "21.661,7.643 13.396,19.328 9.429,15.361 7.075,17.714 13.745,24.384 24.345,9.708",
//     fill: "rgba(255,255,255,1)",
//     id: checkmarkIdPrefix + index
//   });
//   let circle_outline = createSVG("path", {
//     d: "M16,0C7.163,0,0,7.163,0,16s7.163,16,16,16s16-7.163,16-16S24.837,0,16,0z M16,30C8.28,30,2,23.72,2,16C2,8.28,8.28,2,16,2 c7.72,0,14,6.28,14,14C30,23.72,23.72,30,16,30z",
//     fill: "white"
//   });
//   let circle = createSVG("circle", {
//     id: checkmarkCircleIdPrefix + index,
//     fill: "rgba(255,255,255,0)",
//     cx: 16,
//     cy: 16,
//     r: 15
//   });
//   return createSVG("g", { transform: `translate(10 ${yOffset - 20}) scale(.9)` }, [circle, check, circle_outline]);
// }

// function addPhrasesToDocument(phrases) {
//   phrases.forEach((phrase, index) => {
//     let yOffset = 30 + verticalSpacing * index;
//     document.getElementById("phrases").appendChild(createPhraseSvg(phrase, yOffset));
//     document.getElementById("phrases").appendChild(createCheckSvg(yOffset, index));
//   });
// }

// function easeInOut(t) {
//   return 0.5 * (1 - Math.cos(Math.PI * t));
// }

// let phrases = shuffleArray(["Feeding unicorns", "Grabbing tasks", "Collating conversations "]);
// addPhrasesToDocument(phrases);

// let start_time = performance.now();
// let upward_moving_group = document.getElementById("phrases");
// upward_moving_group.currentY = 0;

// let checks = phrases.map((_, i) => ({
//   check: document.getElementById(checkmarkIdPrefix + i),
//   circle: document.getElementById(checkmarkCircleIdPrefix + i)
// }));

// // Calculate threshold where all phrases are out of view
// const yThreshold = -(30 + (phrases.length - 1) * verticalSpacing);

// function animateLoading() {
//   let now = performance.now();
//   let progress = Math.min((now - start_time) / 30000, 1);

//   upward_moving_group.setAttribute("transform", `translate(0 ${upward_moving_group.currentY})`);
//   upward_moving_group.currentY -= 1.35 * easeInOut(progress);

//   checks.forEach((check, i) => {
//     let color_change_boundary = -i * verticalSpacing + verticalSpacing + 15;
//     if (upward_moving_group.currentY < color_change_boundary) {
//       let alpha = Math.max(Math.min(1 - (upward_moving_group.currentY - color_change_boundary + 15) / 30, 1), 0);
//       check.circle.setAttribute("fill", `rgba(255, 255, 255, ${alpha})`);
//       let check_color = [Math.round(255 * (1 - alpha) + 120 * alpha), Math.round(255 * (1 - alpha) + 154 * alpha)];
//       check.check.setAttribute("fill", `rgba(255, ${check_color[0]},${check_color[1]}, 1)`);
//     }
//   });

//   // Hide group when scrolled past threshold
//   if (upward_moving_group.currentY <= yThreshold) {
//     upward_moving_group.style.display = "none";
//     console.log("Animation complete!");
//     return;
//   }

//   requestAnimationFrame(animateLoading);
// }

// animateLoading();
  //loading js content -code-pen
// var checkmarkIdPrefix = "loadingCheckSVG-";
// var checkmarkCircleIdPrefix = "loadingCheckCircleSVG-";
// var verticalSpacing = 50;

// function shuffleArray(array) {
//     for (let i = array.length - 1; i > 0; i--) {
//         let j = Math.floor(Math.random() * (i + 1));
//         [array[i], array[j]] = [array[j], array[i]];
//     }
//     return array;
// }

// function createSVG(tag, properties, opt_children) {
//   let newElement = document.createElementNS("http://www.w3.org/2000/svg", tag);
//   for (let prop in properties) {
//     newElement.setAttribute(prop, properties[prop]);
//   }
//   if (opt_children) {
//     opt_children.forEach(child => newElement.appendChild(child));
//   }
//   return newElement;
// }

// function createPhraseSvg(phrase, yOffset) {
//   let text = createSVG("text", {
//     fill: "white",
//     x: 50,
//     y: yOffset,
//     "font-size": 18,
//     "font-family": "Arial"
//   });
//   text.appendChild(document.createTextNode(phrase + "..."));
//   return text;
// }

// function createCheckSvg(yOffset, index) {
//   let check = createSVG("polygon", {
//     points: "21.661,7.643 13.396,19.328 9.429,15.361 7.075,17.714 13.745,24.384 24.345,9.708",
//     fill: "rgba(255,255,255,1)",
//     id: checkmarkIdPrefix + index
//   });
//   let circle_outline = createSVG("path", {
//     d: "M16,0C7.163,0,0,7.163,0,16s7.163,16,16,16s16-7.163,16-16S24.837,0,16,0z M16,30C8.28,30,2,23.72,2,16C2,8.28,8.28,2,16,2 c7.72,0,14,6.28,14,14C30,23.72,23.72,30,16,30z",
//     fill: "white"
//   });
//   let circle = createSVG("circle", {
//     id: checkmarkCircleIdPrefix + index,
//     fill: "rgba(255,255,255,0)",
//     cx: 16,
//     cy: 16,
//     r: 15
//   });
//   return createSVG("g", { transform: `translate(10 ${yOffset - 20}) scale(.9)` }, [circle, check, circle_outline]);
// }

// function addPhrasesToDocument(phrases) {
//   phrases.forEach((phrase, index) => {
//     let yOffset = 30 + verticalSpacing * index;
//     document.getElementById("phrases").appendChild(createPhraseSvg(phrase, yOffset));
//     document.getElementById("phrases").appendChild(createCheckSvg(yOffset, index));
//   });
// }

// function easeInOut(t) {
//   return 0.5 * (1 - Math.cos(Math.PI * t));
// }

// let phrases = shuffleArray(["Feeding unicorns", "Grabbing tasks", "Collating conversations "]);
// addPhrasesToDocument(phrases);

// let start_time = performance.now();
// let upward_moving_group = document.getElementById("phrases");
// upward_moving_group.currentY = 0;

// let checks = phrases.map((_, i) => ({
//   check: document.getElementById(checkmarkIdPrefix + i),
//   circle: document.getElementById(checkmarkCircleIdPrefix + i)
// }));

// function animateLoading() {
//   let now = performance.now();
//   let progress = Math.min((now - start_time) / 30000, 1);

//   upward_moving_group.setAttribute("transform", `translate(0 ${upward_moving_group.currentY})`);
//   upward_moving_group.currentY -= 1.35 * easeInOut(progress);

//   checks.forEach((check, i) => {
//     let color_change_boundary = -i * verticalSpacing + verticalSpacing + 15;
//     if (upward_moving_group.currentY < color_change_boundary) {
//       let alpha = Math.max(Math.min(1 - (upward_moving_group.currentY - color_change_boundary + 15) / 30, 1), 0);
//       check.circle.setAttribute("fill", `rgba(255, 255, 255, ${alpha})`);
//       let check_color = [Math.round(255 * (1 - alpha) + 120 * alpha), Math.round(255 * (1 - alpha) + 154 * alpha)];
//       check.check.setAttribute("fill", `rgba(255, ${check_color[0]},${check_color[1]}, 1)`);
//     }
//   });

//   if (progress < 1 || upward_moving_group.currentY > -100) {
//     requestAnimationFrame(animateLoading);
//   } else {
//     console.log("Animation complete!");
//   }
// }

// // animateLoading();
// let phrases = shuffleArray(["Feeding unicorns", "Grabbing tasks", "Collating conversations"]);
// addPhrasesToDocument(phrases);

// let currentIndex = 0;
// let checks = phrases.map((_, i) => ({
//   check: document.getElementById(checkmarkIdPrefix + i),
//   circle: document.getElementById(checkmarkCircleIdPrefix + i)
// }));

// function showPhrase(index) {
//   let phraseElement = document.querySelectorAll('#phrases text')[index];
//   let checkElement = checks[index];

//   // Reset any transforms
//   phraseElement.style.transform = "none";

//   // Show phrase with a fade-in
//   phraseElement.style.opacity = 1;

//   // Animate checkmark and circle
//   checkElement.circle.setAttribute("fill", "rgba(255, 255, 255, 1)");
//   checkElement.check.setAttribute("fill", "rgba(120, 255, 154, 1)");

//   setTimeout(() => {
//     // Fade out the current phrase after a short delay
//     phraseElement.style.opacity = 0.3;
//     if (index + 1 < phrases.length) {
//       showPhrase(index + 1);
//     }
//   }, 2000);
// }

// // Start animation
// showPhrase(currentIndex);

const texts = [
    "Generating your mosaic...",
    "Collecting brilliant moments...",
    "Filling the canvas with memories...",
    "Weaving fragments of joy...",
    "Illuminating hidden connections...",
    "Polishing each memory facet...",
    "Aligning colorful experiences...",
    "Energizing the picture...",
    "Amplifying emotional hues...",
    "Crystallizing your story...",
];
        
        const carousel = document.getElementById('textCarousel');
        let currentIndex = 0;
        
        function createTextElement(text, className) {
            const element = document.createElement('div');
            element.className = `text-item ${className}`;
            
            const textSpan = document.createElement('span');
            textSpan.textContent = text;
            
            const checkmark = document.createElement('span');
            checkmark.className = 'checkmark';
            checkmark.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/></svg>';
                        element.appendChild(checkmark);

            element.appendChild(textSpan);
            
            return element;
        }
        
        function initializeCarousel() {
            // Create initial 3 items
            const item1 = createTextElement(texts[currentIndex % texts.length], 'item-1');
            const item2 = createTextElement(texts[(currentIndex + 1) % texts.length], 'item-2');
            const item3 = createTextElement(texts[(currentIndex + 2) % texts.length], 'item-3');
            
            carousel.appendChild(item1);
            carousel.appendChild(item2);
            carousel.appendChild(item3);
            
            currentIndex += 3;
            
            // Start animation after short delay
            setTimeout(animateCarousel, 1000);
        }
        
        function animateCarousel() {
            // Get current items
            const items = document.querySelectorAll('.text-item');
            
            // Add animation classes
            items[0].classList.add('move-up');  // Top item fades out
            items[1].classList.add('move-up');   // Middle moves to top
            items[2].classList.add('move-up');   // Bottom moves to middle
            
            // Create new item at bottom (initially hidden)
            const newItem = createTextElement(texts[currentIndex % texts.length], 'item-3 new-item');
            carousel.appendChild(newItem);
            
            // After transition completes
            setTimeout(() => {
                // Remove the top item that faded out
                items[0].remove();
                
                // Renumber remaining items
                items[1].className = 'text-item item-1';
                items[2].className = 'text-item item-2';
                
                // Fade in the new item
                newItem.classList.remove('new-item');
                newItem.classList.add('fade-in');
                
                // Update positions after classes changed
                setTimeout(() => {
                    newItem.className = 'text-item item-3';
                }, 600);
                
                currentIndex++;
                
                // Continue the cycle
                setTimeout(animateCarousel, 2000);
            }, 600);
        }
        
        // Start the carousel
        initializeCarousel();

    
 });
